const Mock = require('mockjs')

const List = []

const baseContent = '<p>I am testing data, I am testing data.</p><p><img src="https://wpimg.wallstcn.com/4c69009c-0fd4-4153-b112-6cb53d1cf943"></p>'
const image_uri = 'https://wpimg.wallstcn.com/e4558086-631c-425c-9430-56ffb46e70b3'

List.push({
	id: '1',
	type_name: 'NIKKOR Z 20mm f/1.8 S',
	code1: '018208200931',
	code2: '4960759903372',
	stat: '0'
})
List.push({
	id: '2',
	type_name: 'NIKKOR Z 35mm f/1.8 S',
	code1: '018208200932',
	code2: '4960759903373',
	stat: '1'
})
List.push({
	id: '3',
	type_name: 'NIKKOR Z 50mm f/1.8 S',
	code1: '018208200933',
	code2: '4960759903374',
	stat: '0'
})
  
module.exports = [
  {
    url: '/vue-element-admin/box-type/list',
    type: 'get',
    response: config => {
      return {
        code: 20000,
        data: {
          items: List
        }
      }
    }
  },

  {
    url: '/vue-element-admin/box-type/detail',
    type: 'get',
    response: config => {
      const { id } = config.query
      for (const boxType of List) {
        if (boxType.id === +id) {
          return {
            code: 20000,
            data: boxType
          }
        }
      }
    }
  },

  {
    url: '/vue-element-admin/box-type/pv',
    type: 'get',
    response: _ => {
      return {
        code: 20000,
        data: {
          pvData: [
            { key: 'PC', pv: 1024 },
            { key: 'mobile', pv: 1024 },
            { key: 'ios', pv: 1024 },
            { key: 'android', pv: 1024 }
          ]
        }
      }
    }
  },

  {
    url: '/vue-element-admin/box-type/create',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  },

  {
    url: '/vue-element-admin/box-type/update',
    type: 'post',
    response: _ => {
      return {
        code: 20000,
        data: 'success'
      }
    }
  }
]

